import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=f10c90fc&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=ts&"
export * from "./preview.vue?vue&type=script&lang=ts&"
import style0 from "./preview.vue?vue&type=style&index=0&id=f10c90fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10c90fc",
  null
  
)

export default component.exports